import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'

// assets
import enTranslation from '@dr-keyword-public/locales/en/translation.json'
import esTranslation from '@dr-keyword-public/locales/es/translation.json'

i18n.use(initReactI18next).init({
  lng: 'es',
  fallbackLng: 'es',
  supportedLngs: ['es', 'en'],
  interpolation: { escapeValue: false },
  resources: {
    es: esTranslation,
    en: enTranslation
  }
})

export default i18n
